import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e847cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounting-dashboard-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Connect Orders (New Platform)")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accounting_transaction_table = _resolveComponent("accounting-transaction-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.currentBrandId != null)
      ? (_openBlock(), _createBlock(_component_accounting_transaction_table, {
          key: _ctx.currentBrandId,
          "brand-id": _ctx.currentBrandId,
          "start-date": _ctx.startDate,
          "end-date": _ctx.endDate,
          "start-date-model": _ctx.startDateModel,
          "end-date-model": _ctx.endDateModel
        }, null, 8, ["brand-id", "start-date", "end-date", "start-date-model", "end-date-model"]))
      : _createCommentVNode("", true)
  ]))
}